import CacheService from '../cache-service';

class OpenSourceService extends CacheService {
  getProjects() {
    return this.getCachedData('/api/open-source');
  }
}

const openSourceService = new OpenSourceService();

export default openSourceService;